import { render, staticRenderFns } from "./result-table.vue?vue&type=template&id=039d5af0&scoped=true&"
import script from "./result-table.vue?vue&type=script&lang=js&"
export * from "./result-table.vue?vue&type=script&lang=js&"
import style0 from "./result-table.vue?vue&type=style&index=0&id=039d5af0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039d5af0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VDataTable,VDialog,VIcon,VPagination})
